export default __webpack_public_path__ + "assets/images/Payment_07.9da069.png";